// extracted by mini-css-extract-plugin
module.exports = {"block":"Attribution_block__MxDD1","link":"Attribution_link__L6ZYK","fadeOut":"Attribution_fadeOut__kxgN4"};